"use client";

import Image from "next/image";
import styles from "./CallToAction.module.css";

export default function CallToAction() {
  return (
    <section className={styles.ctaSection} id="cta">
      <div className={`${styles.container} container`}>
        <div className={styles.banner}>
          {/* Decorative glowing blobs */}
          <div className={styles.glowBlob1}></div>
          <div className={styles.glowBlob2}></div>

          <div className={styles.content}>
            <div className={styles.logoIcon}>
              <Image 
                src="/images/moteligo-icon.png" 
                alt="Moteligo Logo Icon" 
                width={36} 
                height={36} 
                style={{ objectFit: "contain" }}
              />
            </div>
            
            <div className={styles.textGroup}>
              <h2 className={styles.title}>Ready to Transform Your Hotel Business?</h2>
              <p className={styles.subtitle}>Join hundreds of hotels already growing with Moteligo.</p>
            </div>
          </div>

          <div className={styles.buttonGroup}>
            <a href="#demo" className={styles.btnWhite}>
              Book a Free Demo
            </a>
            <a href="#register" className={styles.btnOutline}>
              Get Started Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
